import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import WatchVideosApi from './WatchVideosApi';

let settings;

export default settings = {
    key: 'watch/videos',
    zone: 'watch',
    path: '/watch/videos',
    title: "Watch Videos",
    endpoint: WatchVideosApi.endpoint,
    modelName: 'WatchVideos',
    idKey: 'id',
    primaryKey: 'title',
    actions: ['trash', 'clone'],
    indexCaps: ["viewWatchVideos"],
    viewCaps: ["viewWatchVideos"],
    createCaps: ["createWatchVideos"],
    updateCaps: ["updateWatchVideos"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: WatchVideosApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['host', 'sport', 'categories', 'tags'], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['title', 'status', 'type'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Title",
                key: "title",
                type: "text",
            },
            {
                label: "Type",
                key: "type",
                type: "choice",
                options: [
                    { value: "live", label: "Live" },
                    { value: "playback", label: "Playback" },
                ],
            },
            {
                label: "Status",
                key: "status",
                type: "choice",
                options: [
                    { value: "draft", label: "Draft" },
                    { value: "preview", label: "Preview" },
                    { value: "publish", label: "Publish" },
                    { value: "archive", label: "Archive" },
                ],
            },
            {
                label: "Host",
                key: "hostId",
                type: "relationship",
                model: "Hosts",
            },
            {
                label: "Sport",
                key: "sportId",
                type: "relationship",
                model: "Sport",
            },
            {
                label: "Category",
                key: "categoryId",
                type: "relationship",
                model: "WatchCategory",
            },
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Title",
                key: "this",
                format: "ModelLink",
                sort: 'title'
            },
            {
                label: "Sport",
                key: "sport",
                format: "ModelLink",
                sort: 'title'
            },
            {
                label: "Host",
                key: "host",
                format: "ModelLink",
                sort: 'name'
            },
            {
                label: "Status",
                key: "status",
                format: "titleCase",
            },
            {
                label: "Type",
                key: "type",
                format: "titleCase",
            },
            {
                label: "Date",
                key: "date",
                format: "DateTime",
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                format: "actions",
                api: WatchVideosApi,
                settings: settings,
            }
        ];

        return columns;

    },
    singleFetch: WatchVideosApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['host', 'sport', 'categories', 'tags', 'ppvProduct'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit",
                caps: settings.updateCaps
            },
        ]

    },
};